import React, { useContext } from "react";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import AppUIModel from "models/appUIModel";
import Logo from "assets/images/buildking_logo.png";
import { StyledP } from "base/BaseStyle";
import moment from "moment";
import UserModel from "models/userModel";
import {
  Divider,
  LogoImg,
  MenuButton,
  MenuButtonContainer,
  MenuFooter,
  OverLayer,
  Wrapper,
} from "./SlideMenu.styles";
import MenuHeader from "./containers/MenuHeader";
import MenuBody from "./containers/MenuBody";
import Spinner from "../../Spinner";

export default function SlideMenu() {
  const { grantedMenuItems } = useContext(UserModel.Context);

  const appUIModel = useContext(AppUIModel.Context);

  const { menuWidth, showMenu, toggleMenu, isLoading } = appUIModel;

  return (
    <aside>
      {isLoading && <Spinner />}

      <MenuButtonContainer $menuWidth={menuWidth} $showMenu={showMenu}>
        <MenuButton onClick={() => toggleMenu(!showMenu)}>
          {showMenu ? <ArrowBackIosNewIcon /> : <ArrowForwardIosIcon />}
        </MenuButton>
      </MenuButtonContainer>
      <OverLayer $showMenu={showMenu} />
      <Wrapper $showMenu={showMenu} $menuWidth={menuWidth}>
        <MenuHeader />
        <Divider />
        <MenuBody appUIModel={appUIModel} grantedMenuItems={grantedMenuItems} />
        <MenuFooter>
          <LogoImg src={Logo} />
          <StyledP fontSize="9" color="text">
            {`© ${moment().year()} Cerebro Strategy Limited. All rights reserved.`}
          </StyledP>
        </MenuFooter>
      </Wrapper>
    </aside>
  );
}
